/**
 * Template Elements - Reusable components for rendering template elements
 * 
 * This module provides a consistent set of components for rendering template elements
 * across both the admin template builder and the user-facing workspace.
 * 
 * Key principles:
 * - Single source of truth for color resolution
 * - Consistent styling across all contexts
 * - Clear separation of concerns
 * - Type-safe component interfaces
 */

// Core types and utilities
export type {
  BaseElementProps,
  ImageElementProps,
  TextElementProps,
  RatingElementProps,
  ReviewSourceElementProps,
  ReviewData,
} from "./types";

export {
  resolveDynamicColor,
  resolveRatingStarColor,
  mapTextStyle,
  normalizePadding,
  calculateAutoFontSize,
  getLineClampStyles,
  getVerticalAlignStyles,
} from "./utils";

// Element components
export { ProfileImageElement } from "./ProfileImageElement";
export type { ProfileImageElementProps } from "./ProfileImageElement";

export { RatingElement } from "./RatingElement";
export type { RatingElementComponentProps } from "./RatingElement";

export { ReviewSourceElement } from "./ReviewSourceElement";
export type { ReviewSourceElementComponentProps } from "./ReviewSourceElement";

export { BrandLogoElement } from "./BrandLogoElement";
export type { BrandLogoElementProps } from "./BrandLogoElement";

export { TextElement } from "./TextElement";
export type { TextElementComponentProps } from "./TextElement";
